import React, { Component } from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

class StepBar extends Component {
  render () {
    const { step, tier, prefectureId } = this.props;
    let tierUrl = "#", prefectureUrl = "#";

    if(tier) 
      tierUrl = "/find_comparable_markets/tier/" + tier;

    if(tier && prefectureId)
      prefectureUrl = "/find_comparable_markets/tier/" + tier + "/prefecture/" + prefectureId;

    return (
      <Container fluid={true} className="sl-step-shell">
        <Row>
          <Col md="12">
            <div className="step-indicator">
              <p 
                className={step >= 1 ? "step completed" : "step"}
                onClick={() => window.location = "/find_comparable_markets/index"}>
                1. Select a Prefecture Tier
              </p>
              <p 
                className={step >= 2 ? "step completed" : "step"}
                onClick={() => window.location = tierUrl}>
                2. Select Prefecture
              </p>
              <p 
                className={step >= 3 ? "step completed" : "step"}
                onClick={() => window.location = prefectureUrl}>
                3. Select a Comparable Market
              </p>
              <p 
                className={step >= 4 ? "step completed" : "step"}>
                4. Explore Comparable Prefecture Data
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default StepBar;

